/* eslint-disable no-unused-vars */
export enum CatalogsMethod {
	goods = 'goods',
	fuels = 'fuels',
	goods_fuelsandmoney = 'goods_fuelsandmoney',
	fuelstations = 'fuelstations',
	categories = 'categories',
	regions = 'regions',
	countries = 'countries',
	statuscards = 'statuscards',
	brands = 'brands',
}

export interface Catalog {
	ref: string;
	name: string;
	contry?: string;
}

export interface CatalogAdapter {
	Ссылка: string;
	Наименование: string;
	Страна?: string;
}

export interface CatalogsGoodsAdapter {
	Ссылка: string;
	Наименование: string;
	НаименованиеПолное: string;
	КодТовара: number;
	ЕдиницаИзмерения: string;
	НоменклатураЦвет: string;
}

export interface CatalogsGoods {
	nomenclature: string; //Ссылка
	nomenclatureName: string; //Наименование
	nomenclatureFullName: string; //НаименованиеПолное
	code: number; //КодТовара
	unit: string; //ЕдиницаИзмерения
	nomenclatureColor: string; //НоменклатураЦвет
}

export interface CatalogsFuelStations {
	brand: string; //Бренд
	countryRef: string; //СтранаСсылка
	physicalAddress: string; //ФизическийАдрес
	serveFuelCard: string; //ОбслуживаетТопливнуюКарту
	countryName: string; //СтранаНаименование
	latitude: number; //Широта
	longitude: number; //Долгота
	regionName: string; //РегионНаименование
	translationAddress: string; //ПереводАдрес
	regionRef: string; //РегионСсылка
	categoryName: string; //КатегорияНаименование
	categoryRef: string; //КатегорияСсылка
	subdivision: string; //Подразделение
	translationName: string; //ПереводНаименование
	name: string; //Наименование
	brandName: string; //БрендНаименование
	code: string; //Код
	ref: string; //Ссылка
}

export interface CatalogsFuelStationsAdapter {
	Бренд: string;
	СтранаСсылка: string;
	ФизическийАдрес: string;
	ОбслуживаетТопливнуюКарту: string;
	СтранаНаименование: string;
	Широта: number;
	Долгота: number;
	РегионНаименование: string;
	ПереводАдрес: string;
	РегионСсылка: string;
	КатегорияНаименование: string;
	КатегорияСсылка: string;
	Подразделение: string;
	ПереводНаименование: string;
	Наименование: string;
	БрендНаименование: string;
	Код: string;
	Ссылка: string;
}
